import styled from 'styled-components';

import { HoverDropdownMenu } from 'shared/components/HoverDropdownMenu';
import { LoggedInDropdownMenu } from 'layout/header/components/LoggedInDropdownMenu';
import { LoggedOutDropdownMenu } from 'layout/header/components/LoggedOutDropdownMenu';
import { variableFontRegular } from 'styles/theme/text';
import { SizePreferencesModalProvider } from 'sizePreferences/providers/SizePreferencesModalProvider';
import { useWindowSize } from 'shared/hooks/useWindowSize';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { FeatureFlags } from 'featureFlags/constants';
import { useStoreSelector } from 'store/hooks/storeHooks';
import { t } from 'localization/utils/t';

const TP = 'layout.header.components.Account';

const MenuItem = () => {
  const { isAuthenticated, user } = useStoreSelector((state) => state.auth);
  const isGuestCheckoutEnabled = useFeatureFlag(FeatureFlags.WEB_ENABLE_GUEST_CHECKOUT);

  const getDisplayText = () => {
    if (!isAuthenticated || (user?.isGuest && isGuestCheckoutEnabled)) {
      return t(`${TP}.account`, 'Account');
    }

    return user?.name;
  };

  return (
    <MenuItem.Wrapper data-qa="account_header" tabIndex={0}>
      {getDisplayText()}
    </MenuItem.Wrapper>
  );
};

export const Account = () => {
  const { isAuthenticated, user } = useStoreSelector((state) => state.auth);
  const { isDesktop } = useWindowSize();
  const isGuestUser = user?.isGuest;

  const menu =
    isAuthenticated && !isGuestUser ? <LoggedInDropdownMenu /> : <LoggedOutDropdownMenu />;

  return (
    <SizePreferencesModalProvider>
      {!isDesktop ? (
        <>
          {isAuthenticated && <MenuItem />}
          {menu}
        </>
      ) : (
        <HoverDropdownMenu dropdownMenu={menu} menuItem={<MenuItem />} align="right" />
      )}
    </SizePreferencesModalProvider>
  );
};

MenuItem.Wrapper = styled.div`
  ${variableFontRegular()};

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumLarge}px) {
    color: ${({ theme }) => theme.navigation.textColor};
    cursor: pointer;
    padding: 10px 0;
    white-space: nowrap;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mediumLarge - 1}px) {
    color: ${({ theme }) => theme.colors.darkGray};
    padding: 8px 0 32px 0;
    ${variableFontRegular({ height: '12px' })};
  }
`;
